import {
  contentMigrationStatusReducer,
  tagsReducer,
  appConfigReducer,
  appDataReducer,
  tpaSettingsReducer,
} from '@wix/communities-blog-client-common';
import search from '../search/reducers/search-reducer';
import { promisifiedActionsResults } from './actions-promisifier/store/promisified-actions-reducer';
import { fastFormSubmit } from './components/fast-form/store/fast-form-reducer';
import { message as messageReducer } from './messages/framework/store/message-reducer';
import { modal } from './modals/framework/store/reducer';
import { router } from './router';
import { appLoaded } from './store/app-loaded/app-loaded-reducer';
import { appSettings } from './store/app-settings/app-settings-reducer';
import auth from './store/auth/auth-reducer';
import { basicParams } from './store/basic-params/basic-params-reducer';
import categories from './store/categories/categories-reducer';
import { communitiesContext } from './store/communities-context/communities-context-reducer';
import customRoutes from './store/custom-routes/custom-routes-reducer';
import { debugState } from './store/debug-state/debug-state-reducer';
import editorConfig from './store/editor-config/editor-config-reducer';
import experiments from './store/experiments/experiments-reducer';
import headerWidget from './store/header-widget/header-widget-reducer';
import { instanceValues } from './store/instance-values/instance-values-reducer';
import isLoaded from './store/is-loaded/is-loaded-reducer';
import isLoading from './store/is-loading/is-loading-reducer';
import isSaving from './store/is-saving/is-saving-reducer';
import locale from './store/locale/locale-reducer';
import { maNavigation } from './store/ma-navigation/ma-navigation-reducer';
import message from './store/message/message-reducer';
import pagination from './store/pagination/pagination-reducer';
import paywall from './store/paywall/paywall-reducer';
import postCounters from './store/post-counters/post-counters-reducer';
import postLikes from './store/post-likes/post-likes-reducer';
import postRatings from './store/post-ratings/post-ratings-reducer';
import postSubscription from './store/post-subscription/post-subscription-reducer';
import posts from './store/posts/posts-reducer';
import profileUrls from './store/profile-urls/profile-urls-reducer';
import searchInput from './store/search-input/search-input-reducer';
import siteProperties from './store/site-properties/site-properties-reducer';
import topology from './store/topology/topology-reducer';
import { translations } from './store/translations/translations-reducer';
import writers from './store/writers/writers-reducer';

export default {
  MESSAGE: messageReducer,
  modal,
  router,
  appConfig: appConfigReducer,
  appData: appDataReducer,
  appLoaded,
  appSettings,
  auth,
  basicParams,
  categories,
  communitiesContext,
  contentMigration: contentMigrationStatusReducer,
  debugState,
  editorConfig,
  experiments,
  fastFormSubmit,
  headerWidget,
  instanceValues,
  isLoaded,
  isLoading,
  isSaving,
  locale,
  maNavigation,
  message,
  pagination,
  posts,
  postCounters,
  postRatings,
  postLikes,
  postSubscription,
  promisifiedActionsResults,
  search,
  searchInput,
  siteProperties,
  topology,
  translations,
  writers,
  paywall,
  tags: tagsReducer,
  tpaSettings: tpaSettingsReducer,
  profileUrls,
  customRoutes,
};
